import { DictionaryListItemDto } from '@/api/generated';
import {
  DictionaryTypeOptionsTranslation,
  dictionaryTypeOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { DictionaryAddModel } from '@/views/dictionaries/list/components/dialog/model/DictionaryAdd.model.ts';
import { DictionariesListSearchFormModel } from '@/views/dictionaries/list/model/DictionariesListSearchForm.model.ts';

export type DictionariesListViewTranslation = {
  dialog: {
    add: {
      button: {
        cancel: string;
        save: string;
        saveAndAdd: string;
      };
      dictionaryTypeOptions: DictionaryTypeOptionsTranslation;
      form: Record<keyof DictionaryAddModel, string>;
      title: {
        create: string;
        update: string;
      };
    };
    calendar: {
      bookingMode: {
        exactTime: string;
        exactTimeDescription: string;
        fullDay: string;
        fullDayDescription: string;
        label: string;
      };
      button: { cancel: string; save: string };
      conflict: {
        close: string;
        count: string;
        description: string;
        offer: string;
        range: string;
        recurring: string;
        recurringAnonymous: string;
        title: string;
      };
      enabled: string;
      enabledDescription: string;
      requiresAssembly: { description: string; disableWarning: string; label: string };
      occupancyMode: {
        exclusive: string;
        exclusiveDescription: string;
        label: string;
        shared: string;
        sharedDescription: string;
      };
      title: string;
    };
    delete: {
      button: {
        cancel: string;
        delete: string;
      };
      content: string;
      title: string;
    };
  };
  table: {
    body: Record<keyof Omit<DictionaryListItemDto, 'dictionaryId'>, string> & {
      actions: string;
      activeStatus: {
        disabled: string;
        enabled: string;
      };
      calendar: string;
      calendarStatus: {
        disabled: string;
        enabled: string;
      };
      dictionaryTypesOptions: DictionaryTypeOptionsTranslation;
    };
    button: {
      add: string;
      calendar: string;
    };
    dictionaryTypesOptions: DictionaryTypeOptionsTranslation;
    head: Record<keyof DictionariesListSearchFormModel, string> & {
      dictionaryTypesOptions: DictionaryTypeOptionsTranslation;
    };
  };
};

export const dictionariesListViewTranslation: DictionariesListViewTranslation = {
  dialog: {
    add: {
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
        saveAndAdd: 'Zapisz i dodaj kolejny',
      },
      dictionaryTypeOptions: dictionaryTypeOptionsTranslation,
      form: {
        active: 'Włączony',
        name: 'Nazwa',
        type: 'Typ',
      },
      title: {
        create: 'Dodaj wpis dla słownika {{dictType}}',
        update: 'Zaktualizuj wpis',
      },
    },
    calendar: {
      bookingMode: {
        exactTime: 'Dokładny czas',
        exactTimeDescription:
          'Rezerwacje uwzględniają datę i godzinę rozpoczęcia oraz zakończenia.',
        fullDay: 'Pełne dni',
        fullDayDescription: 'Rezerwacje obejmują całe dni, niezależnie od godzin.',
        label: 'Sposób rezerwacji',
      },
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
      },
      conflict: {
        close: 'Rozumiem',
        count: 'Wykryte konflikty: {{count}}',
        description:
          'Nie można zapisać zmiany, ponieważ spowodowałaby konflikty istniejących potwierdzonych rezerwacji lub nałożenie się rezerwacji stałych.',
        offer: 'Oferta {{id}}',
        range: '{{from}} – {{to}}',
        recurring: 'Rezerwacja stała „{{name}}”',
        recurringAnonymous: 'Rezerwacja stała',
        title: 'Nie można zapisać zmiany',
      },
      enabled: 'Włącz kalendarz dla tego typu słownika',
      enabledDescription:
        'Po włączeniu elementy tego typu będzie można rezerwować w określonych terminach ofert.',
      requiresAssembly: {
        description:
          'Pozycje oferty z rezerwacją elementu tego typu mogą mieć montaż przed imprezą i demontaż po niej (ustawiane w pozycji oferty). Włączenie niczego nie zmienia w istniejących pozycjach. Domyślnie wyłączone.',
        disableWarning:
          'Wyłączenie usunie montaż, demontaż, ich opisy i okna zasobu wszystkich pozycji tego typu we wszystkich ofertach. Tej zmiany nie można cofnąć.',
        label: 'Wymaga montażu',
      },
      occupancyMode: {
        exclusive: 'Wyłączny',
        exclusiveDescription:
          'Element to zasób o pojemności jeden: potwierdzona rezerwacja blokuje go w swoim terminie dla innych ofert.',
        label: 'Tryb zajętości',
        shared: 'Współdzielony',
        sharedDescription:
          'Element to dodatek do oferty, który można rezerwować w wielu ofertach naraz, bez limitu. Rezerwacje się nie blokują.',
      },
      title: 'Kalendarz rezerwacji',
    },
    delete: {
      button: {
        cancel: 'Anuluj',
        delete: 'Usuń',
      },
      content:
        'Usunięcie spowoduje wyłączenie wartości słownika. Będzie on nadal dostepny w dotychczas wykorzystujących go elementach, lecz nie będzie można używać go przy tworzeniu nowych bądź edycji istniejących elementów',
      title: 'Potwierdź usunięcie wartości słownika',
    },
  },
  table: {
    body: {
      actions: '',
      active: 'Status',
      activeStatus: {
        disabled: 'Wyłączone',
        enabled: 'Włączone',
      },
      calendar: 'Kalendarze',
      calendarStatus: {
        disabled: 'Wyłączone',
        enabled: 'Włączone',
      },
      dictionaryTypesOptions: dictionaryTypeOptionsTranslation,
      name: 'Nazwa',
      type: 'Typ',
    },
    button: {
      add: 'Dodaj',
      calendar: 'Kalendarze',
    },
    dictionaryTypesOptions: dictionaryTypeOptionsTranslation,
    head: {
      active: 'Włączone',
      dictionaryTypesOptions: dictionaryTypeOptionsTranslation,
      fullTextSearchInput: 'Szukaj',
      types: 'Typy',
    },
  },
};
